<template>

  <a
    v-if="!esconderLinkWhatsapp"
    :href="whatsappThemeLink"
    target="_whatsapp"
    class="link-whatsapp"
    :title="$t('footer.talkToTutor')"
  />

  <!-- Footer Top -->
  <div class="footer-top">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6">
          <div class="footer-widget footer-about">
            <div class="footer-logo">
              <div class="img-fluid bg-logo mb-2" style="width: 100%; height: 40px; display: table"/>
            </div>
            <div class="footer-about-content">
              <p v-if="getTheme == 'uca'">{{ $t('footer.ucaSubtitle') }}</p>
              <p v-if="getTheme == 'esn'">{{ $t('footer.esnSubtitle') }}</p>
            </div>

            <div class="sign-google">
              <ul v-if="getTheme == 'uca'">
                <li>
                  <a href="https://www.instagram.com/faculdadecatolicaead/" target="_instagram">
                    <img src="../../src/assets/img/uca/social/net-icon-instagram.png" class="img-fluid rounded-pill">
                  </a>
                </li>
                <li>
                  <a href="https://facebook.com/ucaead" target="_facebook">
                    <img src="../../src/assets/img/uca/social/net-icon-facebook.png" class="img-fluid rounded-pill">
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/@UcaEduBr" target="_youtube">
                    <img src="../../src/assets/img/uca/social/net-icon-youtube.png" class="img-fluid rounded-pill">
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/school/faculdade-catolica-paulista/?originalSubdomain=br"
                     target="_linkedin">
                    <img src="../../src/assets/img/uca/social/net-icon-linkedin.png" class="img-fluid rounded-pill">
                  </a>
                </li>
              </ul>
              <ul v-if="getTheme == 'esn'">
                <li>
                  <a href="https://www.instagram.com/faculdadeesn" target="_instagram">
                    <img src="../../src/assets/img/uca/social/net-icon-instagram.png"
                         class="img-fluid rounded-pill">
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/esnfaculdade" target="_facebook">
                    <img src="../../src/assets/img/uca/social/net-icon-facebook.png" class="img-fluid rounded-pill">
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/channel/UCEgMW7fL-4Uet5PqDqa_iHA" target="_youtube">
                    <img src="../../src/assets/img/uca/social/net-icon-youtube.png" class="img-fluid rounded-pill">
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="footer-widget footer-menu">
            <h2 class="footer-title">{{ $t('footer.contact') }}</h2>
            <ul v-if="getTheme == 'uca'">
              <li>{{ $t('footer.whatsapp') }} :<a :href="getUCAWhatsappLink" target="_blank"><b> (14) 9.8826-3000</b></a></li>
              <li><a href="tel:14-3422-1815">{{ $t('footer.phoneSede') }}: <b>(14) 3422-1815</b></a></li>
              <li><a href="tel:0800-664-5583"> {{ $t('footer.callCenter') }}: <b>0800 664 5583</b></a></li>
              <li>{{ $t('footer.email') }} : <a href="mailto:secretaria@uca.edu.br"><strong>secretaria@uca.edu.br</strong></a></li>
            </ul>
            <ul v-if="getTheme == 'esn'">
              <li>{{ $t('footer.whatsapp') }} :<a :href="getESNWhatsappLink" target="_blank"><b> (14)
                9.8227-2827</b></a></li>
              <li><a href="tel:14-98227-2827">{{ $t('footer.phone') }}: <b>(14) 98227-2827</b></a></li>
              <li>{{ $t('footer.email') }} : <a href="mailto:atendimento@esn.edu.br"><strong>atendimento@esn.edu.br</strong></a></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="footer-widget footer-contact">
            <h2 class="footer-title">{{ $t('footer.address') }}</h2>
            <div class="footer-contact-info">
              <div class="footer-address">
                <img src="../assets/img/icon/icon-20.svg" alt="" class="img-fluid">
                <a href="https://maps.app.goo.gl/wWsD9QX5fVPa3h6PA" target="_map">{{ $t('footer.addressText') }}</a>
              </div>
            </div>
            <h2 class="footer-title">{{ $t('footer.businessHours') }}</h2>
            <div class="footer-contact-info">
              <div class="footer-address">
                <p v-if="getTheme == 'uca'">{{ $t('footer.businessHoursText') }}
                  <br>{{ $t('footer.businessHoursFriday') }}</p>
                <p v-if="getTheme == 'esn'">{{ $t('footer.businessHoursText') }}
                  <br>{{ $t('footer.businessHoursFriday') }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- /Footer Top -->
</template>
<script>
import Helper from "../../src/helpers/helper.service";
import atividadeSessaoService from "../helpers/atividadeSessao.service";
import { resolveThemeLink } from "../helpers/resolveTheme";

export default {
  name: "footertop",
  computed: {
    esconderLinkWhatsapp() {
      return atividadeSessaoService.esconderLinkWhatsapp();
    },
    getTheme() {
      return Helper.getTheme()
    },
    whatsappThemeLink() {
      return resolveThemeLink(this.getTheme)
    },
    getUCAWhatsappLink() {
      return Helper.getUCAWhatsappLink();
    },
    getESNWhatsappLink() {
      return Helper.getESNWhatsappLink();
    },
  },
}
</script>
